import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Elements } from '@stripe/react-stripe-js';
import translate from '../../../../../commonComponents/translate';
import {
  compose,
  PAYMENT_METHOD,
} from '../../../../../services/utilityFunctions';
import StripePaymentMethodsProp from '../../../../payments/propTypes/StripePaymentMethodsProp';
import StripeCreditCardForm from '../../../../../commonComponents/forms/inputs/StripeCreditCardForm';
import BancontactForm from '../../../../../commonComponents/forms/inputs/BancontactForm';
import { handleRemoveCreditCard } from '../../../../../services/checkoutHelper';
import withCSRF from '../../../../../commonComponents/withCSRF';
import Notifications from '../../../../../services/notifications';
import CreditCardItem from './CreditCardItem';
import SEPADebitItem from './SEPADebitItem';
import BillingProp from '../../../../profile/propTypes/billingProp';
import StripeSEPADebitForm from '../../../../../commonComponents/forms/inputs/StripeSEPADebitForm';
import StripeService from '../../../../../services/stripeService';

function PaymentMethodTypesSelector(props) {
  const {
    t,
    _csrf,
    paymentMethodsTypes,
    paymentSettings: {
      paymentMethods,
      paymentMethodType: tabActive = PAYMENT_METHOD.CREDIT_CARD,
      paymentMethodId,
      accountHolderName,
    },
    billing,
    handleIsLoading,
    updatePaymentMethod,
    allowBankTransfer,
  } = props;
  const cardsList = paymentMethods
    .filter(pm => pm.type === PAYMENT_METHOD.CREDIT_CARD)
    .map(pm => pm.card);
  const sepaList = paymentMethods
    .filter(pm => pm.type === PAYMENT_METHOD.SEPA_DEBIT)
    .map(pm => pm.sepa);

  const stripePromise = StripeService.loadStripe();
  const [addingNewCard, setAddingNewCard] = useState(false);
  const [addingNewSEPADebit, setAddingNewSEPADebit] = useState(false);
  /** HANDLE FUNCTIONS */

  // Callback to parent component
  const handleChangePaymentMethod = (type, payload) => {
    updatePaymentMethod(type, payload);
  };

  // Update state to hide or show the card form
  const handleCloseAddCard = () => {
    setAddingNewCard(false);
  };
  const handleOpenAddCard = () => {
    setAddingNewCard(true);
  };

  const handleCloseAddSEPADebit = () => {
    setAddingNewSEPADebit(false);
  };
  const handleOpenAddSEPADebit = () => {
    setAddingNewSEPADebit(true);
  };

  // Select and unselect card
  const handleSelectPaymentMethod = creditCardId => {
    handleChangePaymentMethod('updatedPaymentMethodSelected', {
      paymentMethodId: creditCardId,
    });
  };

  /** API REQUESTS */
  // Handle Card requests add and delete
  const handleFinishAddCard = async paymentMethod => {
    try {
      // handleIsLoading(true);
      // const response = await handleAddCreditCard(_csrf, result.token);
      handleChangePaymentMethod('updatedUserPaymentMethods', {
        paymentMethods: paymentMethods.concat(paymentMethod),
        paymentMethodId: paymentMethod.id,
      });
      handleCloseAddCard();
      handleIsLoading(false);
    } catch (err) {
      handleCloseAddCard();
      Notifications.showErrorFromRequest(err);
      console.log(err);
      handleIsLoading(false);
    }
  };

  const handleFinishAddSEPADebit = async paymentMethod => {
    try {
      handleChangePaymentMethod('updatedUserPaymentMethods', {
        paymentMethods: paymentMethods.concat(paymentMethod),
        paymentMethodId: paymentMethod.id,
      });
      handleCloseAddSEPADebit();
    } catch (err) {
      handleCloseAddSEPADebit();
      Notifications.showErrorFromRequest(err);
      console.log(err);
    }
  };

  const handleRemovePaymentMethod =
    (paymentMethodType, methodId) => async () => {
      // BRAVON-6742: the last payment method cannot be removed, there must be
      // another one left to select. The API enforces it too.
      if (paymentMethods.filter(c => c.id !== methodId).length === 0) {
        Notifications.showNotificationWarning(
          t('error'),
          t('payment_method_remove_last'),
        );
        return;
      }
      handleIsLoading(true);
      try {
        await handleRemoveCreditCard(_csrf, methodId);
        handleChangePaymentMethod('removePaymentMethod', {
          paymentMethods: paymentMethods.filter(c => c.id !== methodId),
        });
      } catch (err) {
        Notifications.showErrorFromRequest(err);
      }
      if (paymentMethodType === PAYMENT_METHOD.CREDIT_CARD) {
        handleCloseAddCard();
      }
      if (paymentMethodType === PAYMENT_METHOD.SEPA_DEBIT) {
        handleCloseAddSEPADebit();
      }
      handleIsLoading(false);
    };

  return (
    <div className="payment-methods-checkout">
      <div className="subtitle">{t('shop.choose.payment')}</div>
      <ul id="paymentList" className="nav nav-pills nav-fill" role="tablist">
        {paymentMethodsTypes.includes(PAYMENT_METHOD.CREDIT_CARD) && (
          <li className="nav-item">
            <button
              type="button"
              className={`btn-payment-method credit-card nav-link show ${
                tabActive === PAYMENT_METHOD.CREDIT_CARD ? 'active' : ''
              }`}
              onClick={() =>
                handleChangePaymentMethod('changeTab', {
                  tab: PAYMENT_METHOD.CREDIT_CARD,
                })
              }
            >
              <img
                id="creditCardImg"
                src="/images/payment-methods/card.svg"
                alt=""
              />
              <span>{t('payment_method_card')}</span>
            </button>
          </li>
        )}
        {paymentMethodsTypes.includes(PAYMENT_METHOD.PAYPAL) && (
          <li className="nav-item paypal-tab-container">
            <button
              type="button"
              className={`btn-payment-method payment-image nav-link show ${
                tabActive === PAYMENT_METHOD.PAYPAL ? 'active' : ''
              }`}
              onClick={() =>
                handleChangePaymentMethod('changeTab', {
                  tab: PAYMENT_METHOD.PAYPAL,
                })
              }
            >
              <img src="/images/payment-methods/paypal.svg" alt="" />
              <span>{t('payment_method_paypal')}</span>
            </button>
          </li>
        )}
        {paymentMethodsTypes.includes(PAYMENT_METHOD.BANCONTACT) && (
          <li className="nav-item">
            <button
              type="button"
              className={`btn-payment-method payment-image nav-link show ${
                tabActive === PAYMENT_METHOD.BANCONTACT ? 'active' : ''
              }`}
              onClick={() =>
                handleChangePaymentMethod('changeTab', {
                  tab: PAYMENT_METHOD.BANCONTACT,
                })
              }
            >
              <img src="/images/payment-methods/bancontact-logo.svg" alt="" />
              <span>Bancontact</span>
            </button>
          </li>
        )}
        {paymentMethodsTypes.includes(PAYMENT_METHOD.SEPA_DEBIT) && (
          <li className="nav-item">
            <button
              type="button"
              className={`btn-payment-method credit-card nav-link show ${
                tabActive === PAYMENT_METHOD.SEPA_DEBIT ? 'active' : ''
              }`}
              onClick={() =>
                handleChangePaymentMethod('changeTab', {
                  tab: PAYMENT_METHOD.SEPA_DEBIT,
                })
              }
            >
              <img src="/images/payment-methods/bank-transfer.svg" alt="" />
              <span>{t('payment_method_sepa_debit')}</span>
            </button>
          </li>
        )}
        {allowBankTransfer &&
          paymentMethodsTypes.includes(PAYMENT_METHOD.BANK_TRANSFER_MANUAL) && (
            <li className="nav-item">
              <button
                type="button"
                className={`btn-payment-method payment-image nav-link show ${
                  tabActive === PAYMENT_METHOD.BANK_TRANSFER_MANUAL
                    ? 'active'
                    : ''
                }`}
                onClick={() =>
                  handleChangePaymentMethod('changeTab', {
                    tab: PAYMENT_METHOD.BANK_TRANSFER_MANUAL,
                  })
                }
              >
                <img src="/images/payment-methods/bank-transfer.svg" alt="" />
                <span>{t('payment_method_bank_transfer')}</span>
              </button>
            </li>
          )}
      </ul>
      <div className="tab-content">
        {paymentMethodsTypes.includes(PAYMENT_METHOD.CREDIT_CARD) &&
          tabActive === PAYMENT_METHOD.CREDIT_CARD && (
            <div
              className={`tab-pane show ${
                tabActive === PAYMENT_METHOD.CREDIT_CARD ? 'active' : ''
              }`}
            >
              <h3>{`${t('shop.cart.your_cards')}:`}</h3>
              {cardsList.map((creditCard, idx) => (
                <CreditCardItem
                  t={t}
                  key={creditCard.id}
                  idx={idx}
                  creditCard={creditCard}
                  isSelected={creditCard.id === paymentMethodId}
                  onSelectCard={handleSelectPaymentMethod}
                  onRemoveCard={handleRemovePaymentMethod(
                    tabActive,
                    creditCard.id,
                  )}
                />
              ))}
              {!addingNewCard ? (
                <div className="add-new-btn">
                  {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus,jsx-a11y/click-events-have-key-events */}
                  <a
                    role="button"
                    onClick={handleOpenAddCard}
                    className="btn btn-outline-metal m-btn m-btn--icon m-btn--icon-only
                             m-btn--custom m-btn--outline-2x m-btn--pill m-btn--air"
                  >
                    <i className="la la-plus" />
                    <span>{t('add_card_payment')}</span>
                  </a>
                </div>
              ) : (
                <div className="add-new-address">
                  <Elements stripe={stripePromise}>
                    <StripeCreditCardForm
                      t={t}
                      onFinish={handleFinishAddCard}
                      onCancel={handleCloseAddCard}
                      handleIsLoading={handleIsLoading}
                      billing={billing}
                    />
                  </Elements>
                </div>
              )}
            </div>
          )}
        {paymentMethodsTypes.includes(PAYMENT_METHOD.PAYPAL) &&
          tabActive === PAYMENT_METHOD.PAYPAL && (
            <div
              className={`bank-transfer-payment tab-pane show ${
                tabActive === PAYMENT_METHOD.PAYPAL ? 'active' : ''
              }`}
            >
              <h3>{t('shop.checkout.payment.paypal.header')}</h3>
              <span>{t('shop.checkout.payment.bancontact.info')}</span>
              <div className="margin-top-20" />
            </div>
          )}
        {paymentMethodsTypes.includes(PAYMENT_METHOD.BANCONTACT) &&
          tabActive === PAYMENT_METHOD.BANCONTACT && (
            <div
              className={`bank-transfer-payment tab-pane show ${
                tabActive === PAYMENT_METHOD.BANCONTACT ? 'active' : ''
              }`}
            >
              <h3>{t('shop.checkout.payment.bancontact.header')}</h3>
              <span>{t('shop.checkout.payment.bancontact.info')}</span>
              <div className="margin-top-20">
                <BancontactForm
                  onAccountHolder={value =>
                    handleChangePaymentMethod('updateHolderName', {
                      accountHolderName: value,
                    })
                  }
                  accountName={accountHolderName}
                />
              </div>
            </div>
          )}
        {paymentMethodsTypes.includes(PAYMENT_METHOD.SEPA_DEBIT) &&
          tabActive === PAYMENT_METHOD.SEPA_DEBIT && (
            <div
              className={`bank-transfer-payment tab-pane show ${
                tabActive === PAYMENT_METHOD.SEPA_DEBIT ? 'active' : ''
              }`}
            >
              <h3>{t('shop.checkout.payment.sepa.header')}</h3>
              {sepaList.map((sepaDebit, idx) => (
                <SEPADebitItem
                  key={sepaDebit.id}
                  idx={idx}
                  sepaDebit={sepaDebit}
                  isSelected={sepaDebit.id === paymentMethodId}
                  onSelectSEPADebit={handleSelectPaymentMethod}
                  onRemoveSEPADebit={handleRemovePaymentMethod(
                    tabActive,
                    sepaDebit.id,
                  )}
                />
              ))}
              {!addingNewSEPADebit ? (
                <div className="add-new-btn">
                  {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus,jsx-a11y/click-events-have-key-events */}
                  <a
                    role="button"
                    onClick={handleOpenAddSEPADebit}
                    className="btn btn-outline-metal m-btn m-btn--icon m-btn--icon-only
                             m-btn--custom m-btn--outline-2x m-btn--pill m-btn--air"
                  >
                    <i className="la la-plus" />
                    <span>{t('add_new_sepa')}</span>
                  </a>
                </div>
              ) : (
                <div className="add-new-address">
                  <Elements stripe={stripePromise}>
                    <StripeSEPADebitForm
                      t={t}
                      onFinish={handleFinishAddSEPADebit}
                      onCancel={handleCloseAddSEPADebit}
                      handleIsLoading={handleIsLoading}
                      billing={billing}
                    />
                  </Elements>
                </div>
              )}
            </div>
          )}
        {allowBankTransfer &&
          paymentMethodsTypes.includes(PAYMENT_METHOD.BANK_TRANSFER_MANUAL) &&
          tabActive === PAYMENT_METHOD.BANK_TRANSFER_MANUAL && (
            <div
              className={`bank-transfer-payment tab-pane show ${
                tabActive === PAYMENT_METHOD.BANK_TRANSFER_MANUAL
                  ? 'active'
                  : ''
              }`}
            >
              <h3>{t('shop.checkout.payment.bankTransfer.header')}</h3>
              <span>{t('shop.checkout.payment.bankTransfer.info')}</span>
            </div>
          )}
      </div>
    </div>
  );
}

PaymentMethodTypesSelector.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  paymentMethodsTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  paymentSettings: PropTypes.shape({
    paymentMethods: PropTypes.arrayOf(
      PropTypes.shape(StripePaymentMethodsProp.propType),
    ).isRequired,
    paymentMethodType: PropTypes.string.isRequired,
    paymentMethodId: PropTypes.string.isRequired,
    accountHolderName: PropTypes.string,
  }).isRequired,
  billing: PropTypes.shape(BillingProp.propType),
  updatePaymentMethod: PropTypes.func.isRequired,
  handleIsLoading: PropTypes.func.isRequired,
  allowBankTransfer: PropTypes.bool,
};

PaymentMethodTypesSelector.defaultProps = {
  billing: BillingProp.defaultProp,
  allowBankTransfer: false,
};

export default compose(translate, withCSRF)(PaymentMethodTypesSelector);
